import setHexWithAlphaToSolid from './setHexWithAlphaToSolid';

function setTextColorBasedOnBg(hex) {
    let hexColor = hex;
    // Remove the '#' if it exists
    hexColor = hex.replace('#', '');

    if (hexColor.length === 8) {
        hexColor = setHexWithAlphaToSolid(hexColor);
    }
    // Convert hex to RGB
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);

    // Calculate relative luminance
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    // Return text color based on luminance
    return luminance < 128 ? '#FFFFFF' : '#020202';
}

export default setTextColorBasedOnBg